export const shorten = (
  text: string,
  maxLength: number,
  endString: string = "..."
): string =>
  text.length > maxLength
    ? text.slice(0, maxLength - endString.length).concat(endString)
    : text
